import { useEffect, useState } from "react";
import { useAuth } from "../authContext";
import { useSecurity } from "../SecurityContext";
import { fetchMemberProfileCard } from "../components/tools/memberProfileCardApi";

function deriveIsAltAccountFromHandles(handles) {
  if (!Array.isArray(handles) || handles.length === 0) return false;
  const linked = handles.filter((h) => h && h.linkedToUser);
  if (linked.length === 0) return false;
  return !linked.some((h) => h.isMaster !== false);
}

/**
 * Whether the currently viewed identity (self or view-as subject) is an alt-account login.
 */
export function useActiveUserIsAltAccount() {
  const { isAltAccount, handles } = useAuth();
  const { isViewAsActive, viewAsUserId } = useSecurity();
  const [viewAsIsAltAccount, setViewAsIsAltAccount] = useState(false);
  const [viewAsLoading, setViewAsLoading] = useState(false);

  useEffect(() => {
    if (!isViewAsActive || viewAsUserId == null) {
      setViewAsIsAltAccount(false);
      setViewAsLoading(false);
      return undefined;
    }

    let cancelled = false;
    setViewAsLoading(true);

    (async () => {
      try {
        const res = await fetchMemberProfileCard(viewAsUserId);
        if (cancelled) return;
        setViewAsIsAltAccount(Boolean(res?.card?.isAltAccount));
      } catch {
        if (!cancelled) setViewAsIsAltAccount(false);
      } finally {
        if (!cancelled) setViewAsLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isViewAsActive, viewAsUserId]);

  if (isViewAsActive) {
    return { showAltAccountWarning: viewAsIsAltAccount, loading: viewAsLoading };
  }

  const fromHandles = deriveIsAltAccountFromHandles(handles);
  return {
    showAltAccountWarning: Boolean(isAltAccount) || fromHandles,
    loading: false,
  };
}
